<template lang="pug">
    section#conteudoEgressos
        .wrapper
            div.img(v-if="$route.name == 'egressosBeneficios'")
                img(:src="require('@images/egressos/egressos-modelo2.png')", alt="")
            //- div.img(v-if="$route.fullPath == '/egressos'")
                //- img(:src="require('@images/egressos/banner_lateral.jpg')", alt="")
            div.conteudo(v-html="$props.conteudo")
</template>

<script>
export default {
    name: "component-conteudo-egressos",
    props: {
        conteudo: String
    }
}
</script>

<style lang="stylus" scoped src="./ConteudoEgressos.styl"></style>